export default __webpack_public_path__ + "static/media/contrato-menor.916944ca.jpg";